import './parts.css'
export default function Parts({setParts}) {
    function partir(){
        setParts('ir')
    }
    function partnotir(){
        setParts('notir')
    }
    return(
        <div className="partspox">
            <ul>
                <li onClick={partir}>داخلی</li>
                <li onClick={partnotir}>خارجی</li>
            </ul>
        </div>
    )
}